import { componentProvider } from 'js-component-framework';
import VideoPlayer from './video-player';
import './video-player.scss';

const videoPlayerConfig = {
  name: 'video-player',
  component: VideoPlayer,
  querySelector: {
    videoContainer: '[id^="video-container-"]',
    videoLink: '.thumbnail',
    thumbnail: '.figure',
    videoIcon: 'span[data-video-loading]',
  },
  querySelectorAll: {},
  options: {
    playerVars: {
      modestbranding: 1,
      rel: 0,
      autoplay: false,
      enablejsapi: 1,
      playsinline: 1,
    },
  },
};

componentProvider(videoPlayerConfig);
